import * as React from "react";
import pureRender from "pure-render-deepcompare-decorator";
import * as classnames from "classnames";
import * as styles from "./CountDown.scss";

export interface ICountDownProps {
  /** class */
  className?: string;
  countDownStart:number
}

@pureRender
export class CountDown extends React.Component<ICountDownProps, any> {

 

  public render() {
    const {　className } = this.props;
    const classNameSec = classnames(styles.sec, className);
    return (
      <div className={classNameSec} >
        <p className={styles.label}>任务重置倒计时</p>
        <p className={classnames(styles.time)} ref="countdown"></p>
      </div>
    );
  }
  componentDidUpdate(){
    let year=new Date().getFullYear();
    let month=new Date().getMonth()+1    ;
    let date=new Date().getDate()+1;
    let finalTime=new Date(year+'/'+month+'/'+date+' 00:00:00').getTime();
    new f2eGameUI.CountDown({
      $element:$(this.refs.countdown)[0],
      nowTime:this.props.countDownStart,
      finalTime:finalTime,
      modules:{
        day:{
          show:false
        },
        hour:{
          unit:":"
        },
        minute:{
          unit:":"
        },
        second:{
          unit:""
        }
      }
    })
  }
}

export default CountDown;


// WEBPACK FOOTER //
// ./src/components/CountDown/CountDown.tsx